const FAST_HIERARCHY_VERSION = 4;

module.exports = { FAST_HIERARCHY_VERSION };